import {useDispatch, useSelector} from "react-redux";
import AjaxButton from "../../../../form/ajax_button";
import classNames from "classnames";
import {appendAccountSupportChatMessage, updateSupportChatSession} from "../../../actions";
import ChatWindow from "../../../components/common/chat_window";
import React, {useEffect} from "react";
import axios from "axios";

const CloseButton = ({supportChatSession}) => {
  const account = useSelector((state) => state.account)
  const accountCloseSupportChatSessionUrl = useSelector((state) => state.accountCloseSupportChatSessionUrl)
  const accountReopenSupportChatSessionUrl = useSelector((state) => state.accountReopenSupportChatSessionUrl)

  if (supportChatSession.assigned_account_id !== account.id) {
    return null
  } else if (supportChatSession.complete) {
    return <AjaxButton
      key={"reopen"}
      method="put"
      labelSending="Reopening Chat ..."
      className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled ml-2 mb-2")}
      icon="fa-save"
      url={accountReopenSupportChatSessionUrl}
      data={{support_chat_session_id: supportChatSession.id}}
      label={"Reopen Chat"}
      onSuccess={(data) => {
        if (data.data.status === "OK") {
          dispatch(updateSupportChatSession(data.data.support_chat_session))
        } else {
          alert(data.data.message || "A error occurred while reopening the chat.")
        }
      }}
      onError={(error) => {
        console.log(error)
        alert("Error, could not reopen chat.", error)
      }}
    />
  } else {
    return <AjaxButton
      key={"close"}
      method="put"
      labelSending="Closing Chat ..."
      className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled ml-2 mb-2")}
      icon="fa-save"
      url={accountCloseSupportChatSessionUrl}
      data={{support_chat_session_id: supportChatSession.id}}
      label={"Close Chat"}
      onSuccess={(data) => {
        if (data.data.status === "OK") {
          dispatch(updateSupportChatSession(data.data.support_chat_session))
        } else {
          alert(data.data.message || "A error occurred while closing the chat.")
        }
      }}
      onError={(error) => {
        console.log(error)
        alert("Error, could not close chat.", error)
      }}
    />
  }
}

export default function ChatView(props) {
  const dispatch = useDispatch()
  const {supportChatSession} = props

  const account = useSelector((state) => state.account)
  const supportChatMessages = useSelector(state => state.supportChatMessages)
  const accountReleaseSupportChatSessionUrl = useSelector((state) => state.accountReleaseSupportChatSessionUrl)
  const accountMarkMessageAsReadSupportChatSessionUrl = useSelector((state) => state.accountMarkMessageAsReadSupportChatSessionUrl)
  const accountSendSupportChatMessageUrl = useSelector((state) => state.accountSendSupportChatMessageUrl)
  const accountTakeSupportChatSessionUrl = useSelector((state) => state.accountTakeSupportChatSessionUrl)

  const markMessagesAsRead = (supportChatSession) => {
    if (supportChatSession && supportChatSession.assigned_account_id == account.id) {
      const messages = supportChatMessages.filter(scm => scm.support_chat_session_id === supportChatSession.id)
      const unreadMessages = messages.filter((supportChatMessage) => !supportChatMessage.read_by_account)

      if (unreadMessages && unreadMessages.length > 0) {
        const data = {
          support_chat_session_id: supportChatSession.id,
          support_chat_message_ids: unreadMessages.map((message) => message.id)
        };

        axios.put(accountMarkMessageAsReadSupportChatSessionUrl, data).then(response => {
            if (response.data.status === "OK") {
              dispatch(updateSupportChatSession(response.data.support_chat_session))
            } else {
              console.error(response.data.errors);
            }
          },
          error => {
            console.error(error)
          }
        )
      }
    }
  }

  useEffect(() => {
    markMessagesAsRead(supportChatSession)

    const interval = setInterval(() => {
      markMessagesAsRead(supportChatSession)
    }, 15 * 1000)

    return () => clearInterval(interval)
  }, [supportChatSession, supportChatMessages])

  return <div className="row no-gutters overflow-hidden" style={{width: "100%"}}>
    <div className="col-12 shadow px-3 mb-3">
      <div className="row">
        <div className="col-7" style={{display: "flex", alignItems: "center", flexWrap: "wrap"}}>
          <h5>
            <strong>{supportChatSession.tag_owner_name}</strong>
          </h5>
        </div>
        <div className="col-5 text-right p-2">
          <CloseButton supportChatSession={supportChatSession}/>
          {/*{supportChatSession.assigned_account_id !== account.id ? <AjaxButton*/}
          {/*  method="put"*/}
          {/*  labelSending="Taking Chat ..."*/}
          {/*  className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled mb-2")}*/}
          {/*  icon="fa-save"*/}
          {/*  url={accountTakeSupportChatSessionUrl}*/}
          {/*  data={{support_chat_session_id: supportChatSession.id}}*/}
          {/*  label={"Take Chat"}*/}
          {/*  onSuccess={(data) => {*/}
          {/*    if (data.data.status === "OK") {*/}
          {/*      dispatch(updateSupportChatSession(data.data.support_chat_session))*/}
          {/*    } else {*/}
          {/*      alert(data.data.message || "A error occurred while taking the chat.")*/}
          {/*    }*/}
          {/*  }}*/}
          {/*  onError={(error) => {*/}
          {/*    console.log(error)*/}
          {/*    alert("Error, could not take chat.", error)*/}
          {/*  }}*/}
          {/*/> : <AjaxButton*/}
          {/*  method="put"*/}
          {/*  labelSending="Releasing Chat ..."*/}
          {/*  className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled mb-2")}*/}
          {/*  icon="fa-save"*/}
          {/*  url={accountReleaseSupportChatSessionUrl}*/}
          {/*  data={{support_chat_session_id: supportChatSession.id}}*/}
          {/*  label={"Release Chat"}*/}
          {/*  onSuccess={(data) => {*/}
          {/*    if (data.data.status === "OK") {*/}
          {/*      dispatch(updateSupportChatSession(data.data.support_chat_session))*/}
          {/*    } else {*/}
          {/*      alert(data.data.message || "A error occurred while releasing the chat.")*/}
          {/*    }*/}
          {/*  }}*/}
          {/*  onError={(error) => {*/}
          {/*    console.log(error)*/}
          {/*    alert("Error, could not release chat.", error)*/}
          {/*  }}*/}
          {/*/>}*/}
        </div>
      </div>
    </div>
    <div className="col-12">
      <div className="d-flex" style={{flexDirection: "column", maxHeight: "65vh"}}>
        <ChatWindow supportChatSession={supportChatSession}
                    sendMessageUrl={accountSendSupportChatMessageUrl}
                    disableInput={supportChatSession.assigned_account_id !== account.id}
                    onSuccessfullySent={(support_chat_message) => {
                      dispatch(appendAccountSupportChatMessage(support_chat_message))
                    }}/>
      </div>
      <div className="row">
        {supportChatSession.assigned_account_id !== account.id && !supportChatSession.complete &&
        <div className="col-12 text-center">
          <hr/>
          <AjaxButton
            method="put"
            labelSending="Taking Chat ..."
            className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled mb-2")}
            icon="fa-save"
            url={accountTakeSupportChatSessionUrl}
            data={{support_chat_session_id: supportChatSession.id}}
            label={"Take Chat"}
            onSuccess={(data) => {
              if (data.data.status === "OK") {
                dispatch(updateSupportChatSession(data.data.support_chat_session))
              } else {
                alert(data.data.message || "A error occurred while taking the chat.")
              }
            }}
            onError={(error) => {
              console.log(error)
              alert("Error, could not take chat.", error)
            }}
          />
        </div>}
      </div>
    </div>
  </div>
}